import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import Client from '../core';

var FeatureFlagClient = /*#__PURE__*/function () {
  function FeatureFlagClient(apiKey, analyticsWebClient, featureFlagUser, options) {
    _classCallCheck(this, FeatureFlagClient);

    this.client = new Client(apiKey, analyticsWebClient, featureFlagUser, options);
  }

  _createClass(FeatureFlagClient, [{
    key: "ready",
    value: function ready() {
      return this.client.ready();
    }
  }, {
    key: "setAutomaticExposuresEnabled",
    value: function setAutomaticExposuresEnabled(enabled, predicate) {
      this.client.setAutomaticExposuresEnabled(enabled, predicate);
    }
  }, {
    key: "getFlagValue",
    value: function getFlagValue(flagKey, defaultValue, options) {
      return this.client.getFlagValue(flagKey, defaultValue, options);
    }
  }, {
    key: "getFlagDetails",
    value: function getFlagDetails(flagKey, defaultValue, options) {
      return this.client.getFlagDetails(flagKey, defaultValue, options);
    }
  }, {
    key: "getFlags",
    value: function getFlags() {
      return this.client.getFlags();
    }
  }, {
    key: "on",
    value: function on(flagKey, defaultValue, callback, options) {
      return this.client.on(flagKey, defaultValue, callback, options);
    }
  }, {
    key: "onAnyFlagUpdated",
    value: function onAnyFlagUpdated(callback) {
      return this.client.onAnyFlagUpdated(callback);
    }
  }, {
    key: "updateFeatureFlagUser",
    value: function updateFeatureFlagUser(featureFlagUser) {
      return this.client.updateFeatureFlagUser(featureFlagUser);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.client.destroy();
    }
  }]);

  return FeatureFlagClient;
}();

export { FeatureFlagClient as default };